// @todo check all available statuses from response of timeslots, type it in the ITime interface
export const TIME_SLOT_BUSY_STATUS = 2;

export const PROVIDER_ID_COOKIE = 'providerId';
